<style lang="scss">
	.cz-dp{
		position: absolute;
		top: 5px;
		right: 60px;
		width: 120px;
		height: 140px;
		display: flex;
		align-items: center;
		justify-content: center;
		/*background: #eee;*/
		border: 1px solid #ddd;
		border-radius: 10px;
		.icon-text{
			position: absolute;
			right: -5px;
			top: -5px;
			padding: 5px 8px;
			background: #FF7368;
			color: #fff;
			border-radius: 15px 15px 15px 0;
			font-style: normal;
			font-size: 12px;
		}
		.cz-con{
			display: inline-block;
			text-align: center;
			margin-top: -10px;
		}
		.info{
			margin-bottom: 8px;
			color: #000;
		}
		.money{
			margin-bottom: 7px;
			.bold{
				font-size: 18px;
				font-weight: bold;
				color: #b17e47;
			}
			.original{
				font-size: 12px;
				color: #9B988D;
				margin-left: 5px;
			}
		}
		.next{
			font-size: 11px;
		}
		.gold{
			font-size: 14px;
			margin-bottom: 10px;
			color: #21201D;
		}
		.describe{
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			height: 20px;
			line-height: 20px;
			text-align: center;
			background: #f2e1bc;
			border-radius: 0 0 10px 10px;
			font-size: 12px;
		}
	}
</style>
<template>
	<div>
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" ref="formInline" :model="formInline" size="small" class="demo-form-inline">
					<el-form-item>
						<el-button type="success" icon="el-icon-circle-plus-outline"  @click="addData">添加充值模板</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle td20">
					<el-table-column label="模板ID" prop="sinaSigningTemplateId">
					</el-table-column>
					<el-table-column prop="rechargeInfo" label="类型"></el-table-column>
					<el-table-column prop="money" label="首月充值金额"></el-table-column>
					<el-table-column prop="nextMonthPrice" label="次月充值金额"></el-table-column>
					<el-table-column label="操作" width="350">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleLook(scope.row.sinaSigningTemplateId)">详情</el-button>
							<el-button type="primary" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row.sinaSigningTemplateId)">编辑</el-button>
							<el-button type="danger" v-if="scope.row.delFlag == 0" size="mini" @click="handleShield(scope.row.sinaSigningTemplateId, scope.row.delFlag)">屏蔽</el-button>
							<el-button type="success" v-if="scope.row.delFlag == 1" size="mini" @click="handleShield(scope.row.sinaSigningTemplateId, scope.row.delFlag)">启用</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!--<div class="foot-table" style="text-align:center;">-->
					<!--<el-pagination-->
							<!--@current-change="handleCurrentChange"-->
							<!--@size-change="handleSizeChange"-->
							<!--:page-sizes="[20, 50, 100, 200, 500]"-->
							<!--:page-size="tableData.pageSize"-->
							<!--background-->
							<!--:current-page="currentPage"-->
							<!--layout="sizes, prev, pager, next, jumper, ->, total"-->
							<!--:total="tableData.totalNum">-->
					<!--</el-pagination>-->
				<!--</div>-->
			</div>

		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
				<tr>
					<td width="200">模板ID</td>
					<td>
						<span>{{ruleForm.sinaSigningTemplateId}}</span>
					</td>
				</tr>
				<tr>
					<td>类型</td>
					<td>
						<p>{{ruleForm.rechargeInfo}}</p>
					</td>
				</tr>
				<tr>
					<td>首月充值金额</td>
					<td>
						<p>{{ruleForm.money}}</p>
					</td>
				</tr>
				<tr>
					<td>次月充值金额</td>
					<td>
						<p>{{ruleForm.nextMonthPrice}}</p>
					</td>
				</tr>
				<!--<tr>-->
					<!--<td>状态</td>-->
					<!--<td>-->
						<!--<span class="succes-text" v-if="ruleForm.isShowSubscript == 1">已展示：{{ruleForm.subscript}}</span>-->
						<!--<span class="danger-text"  v-if="ruleForm.isShowSubscript == 0">未展示</span>-->
					<!--</td>-->
				<!--</tr>-->
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!--添加-->
		<!--新建编辑-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="650px">
			<div style="position: relative;">
				<el-form :rules="rules" ref="ruleForm" :model="ruleForm" size="small" label-width="150px" class="input320" style="max-height: 480px;overflow: auto; padding-right: 20px;">
					<el-form-item label="模板ID：" clearable prop="sinaSigningTemplateId">
						<el-input type="number" v-model="ruleForm.sinaSigningTemplateId" placeholder="请输入模板ID" clearable></el-input>
					</el-form-item>
					<el-form-item label="类型：" clearable prop="sinaSigningType">
						<el-select v-model="ruleForm.sinaSigningType"  placeholder="选择充值类型" style="width: 320px">
							<el-option
									v-for="item in optionsRechargeType"
									:key="item.value"
									:label="item.label"
									:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="ruleForm.sinaSigningType == 1 ? '首月金额' : '首季金额' " clearable prop="money">
						<el-input type="number" v-model="ruleForm.money" clearable></el-input>
					</el-form-item>
					<el-form-item :label="ruleForm.sinaSigningType == 1 ? '次月金额' : '次季金额' " clearable prop="nextMonthPric">
						<el-input type="number" v-model="ruleForm.nextMonthPrice" clearable></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
    import {listSign, detailsSign, listSignAdd, shield} from "@/api/wb/app/recharge";
    export default {
        name:'WbRechargeTemplate',
        props:['menuPage'],
        data() {
            // var validateNum = (rule, value, callback) => {
            // 	if (!(/(^[1-9]\d*$)/.test(value))) {
            // 		return callback(new Error('数字应为正整数'));
            // 	} else {
            // 		callback();
            // 	}
            // };
            return {
                formInline: {
                    appId: localStorage.getItem('appId')
                },
                dialogTitle: '添加充值模板',
                tableData: {
                    pageSize: 20,
                    pageNo: 1,
                    totalPage: 1,
                    totalNum: 0,
                    result: [
                    ]
                },
                currentPage: 1,
                dialogFormVisible: false,
                // ruleForm: {},
                dialogInfoVisible: false,
                optionsRechargeType: [
                    {
                        value: 1,
                        label: '连续包月'
                    },
                    {
                        value: 2,
                        label: '连续包季'
                    }
                ],
                ruleForm: {
                    change: "add",
                    clientId: 0,
                    delFlag: 0,
                    id: '',
                    money: '',
                    nextMonthPrice: '',
                    rechargeInfo: '',
                    sinaSigningTemplateId: '',
                    sinaSigningType: 1
                },
                rules: {
                    sinaSigningTemplateId: [
                        {required: true, message: '请输入模板ID', trigger: 'blur'},
                        // { validator: validateNum, trigger: 'blur' }
                    ],
                    sinaSigningType: [
                        {required: true, message: '请选择类型', trigger: 'change'}
                    ],
                    money: [
                        {required: true, message: '请输入金额', trigger: 'blur'},
                        // { validator: validateNum, trigger: 'blur' }
                    ],
                    nextMonthPrice: [
                        {required: true, message: '请输入金额', trigger: 'change'}
                    ]
                }
            }
        },
        computed: {},
        watch: {
        },
        mounted: function() {
            this.getTableData()
        },
        methods: {
            // // 分页
            // handleCurrentChange(value) {
            //     this.currentPage = value
            //     this.getTableData()
            // },
            // // pageSize切换
            // handleSizeChange (val) {
            //     this.tableData.pageSize  = val
            //     this.currentPage = 1
            //     this.getTableData()
            // },
            handleLook(id) {
                // this.ruleForm = row
                this.dialogInfoVisible = true
                this.getDetails(id)
            },
            // 编辑
            handleEdit(id) {
                this.dialogTitle = '编辑充值模板'
                this.dialogFormVisible = true
                this.getDetails(id)

            },
            getDetails(id) {
                detailsSign({
                    sinaSigningTemplateId: id,
                }).then(response => {
                    if (response.data.head.flag === 0) {
                        this.ruleForm = response.data.content
                        this.ruleForm.change = 'upd'
                        if (this.$refs['ruleForm'] !== undefined) {
                            this.$refs['ruleForm'].resetFields()
                        }
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });
            },
            addData() {
                // const appName = JSON.parse(localStorage.getItem('appList')).filter(item => item.appId === this.formInline.appId)[0].name
                this.ruleForm = {
                    change: "add",
                    clientId: 0,
                    delFlag: 0,
                    id: '',
                    money: '',
                    nextMonthPrice: '',
                    rechargeInfo: '',
                    sinaSigningTemplateId: '',
                    sinaSigningType: 1
                }
                this.dialogFormVisible = true
                this.dialogTitle = '添加充值模板'


                if (this.$refs['ruleForm'] !== undefined) {
                    this.$refs['ruleForm'].resetFields()
                }
            },
            // 弹框确定
            editDialogSureBtn (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.saveTableData()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 保存编辑信息
            saveTableData () {
                const info = {
                    change: this.ruleForm.change,
                    clientId: this.ruleForm.clientId,
                    delFlag: this.ruleForm.delFlag,
                    id: this.ruleForm.id,
                    money: this.ruleForm.money,
                    nextMonthPrice: this.ruleForm.nextMonthPrice,
                    rechargeInfo: this.ruleForm.rechargeInfo,
                    sinaSigningTemplateId: this.ruleForm.sinaSigningTemplateId,
                    sinaSigningType: this.ruleForm.sinaSigningType
                }
                listSignAdd(info).then(response => {
                    if (response.data.head.flag === 0) {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.getTableData()
                        this.dialogFormVisible = false
                    } else {
                        this.$message.error(response.data.head.desc);
                    }
                })


            },
            getTableData() {
                let json2 = {
                   delFlag: ''
                };
                // let json1 = this.formInline;
                // let paramJson = { ...json1, ...json2 }
                listSign(json2).then(response => {
                    if (response.data.head.flag === 0) {
                        this.tableData.result = response.data.content
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });

            },
			// 屏蔽
            handleShield(id, delFlag) {
                shield({
                    delFlag: delFlag == 0 ? 1 : 0,
                    sinaSigningTemplateId: id,
                }).then(response => {
                    if (response.data.head.flag === 0) {
                        this.getTableData()
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });
            },
        }
    }
</script>
